import fetch from "auth/FetchInterceptor";

const ExpensesService = {};

const expensesEndpointPrefix = "/expenses";

ExpensesService.getexpenses = async () =>
    await fetch(`${expensesEndpointPrefix}/getAll`, {
        method: "GET",
    });

ExpensesService.getExpenseById = async (expenseId) =>
    await fetch(`${expensesEndpointPrefix}/getById/${expenseId}`, {
        method: "GET",
    });

ExpensesService.createExpense = async (data) =>
    await fetch({
        url: `${expensesEndpointPrefix}/create`,
        method: "POST",
        data,
    });

ExpensesService.updateExpense = async (expenseId, data) =>
    await fetch(`${expensesEndpointPrefix}/update/${expenseId}`, {
        method: "PUT",
        data,
    });

ExpensesService.deleteExpenseById = async (expenseId) =>
    await fetch(`${expensesEndpointPrefix}/deleteById/${expenseId}`, {
        method: "DELETE",
    });

export default ExpensesService;
